import { Injectable } from '@angular/core';

const getWindow = () => window;

@Injectable()
export class WindowService {
    get nativeWindow() {
        return getWindow();
    }

    get dataLayer() {
        return (getWindow() as any).dataLayer;
    }

    get drift() {
        return (getWindow() as any).drift;
    }

    get intercom() {
        return (getWindow() as any).Intercom;
    }

    get location() {
        return (getWindow() as any).location;
    }

    set location(location) {
        (getWindow() as any).location = location;
    }

    get pageYOffset() {
        return getWindow().pageYOffset;
    }

    public getElementByClassName(className: string): Element {
        return getWindow().document.getElementsByClassName(className)[0];
    }

    public getElementById(id: string): Element {
        return getWindow().document.getElementById(id);
    }

    public open(location, target = '_blank') {
        getWindow().open(location, target);
    }

    public scrollTo(x: number, y: number) {
        getWindow().scrollTo(x, y);
    }

    public addEventListener(
        event: string,
        listener: EventListenerOrEventListenerObject,
        options?: boolean | AddEventListenerOptions
    ) {
        getWindow().addEventListener(event, listener, options);
    }
}
